export default "__VITE_ASSET__0xEzp0UE__"